import { ChartOptions } from "chart.js";

import { formats } from "@/utils/formats";

export const getInsiderHoldingChartOptions = (): ChartOptions<"bar"> => ({
  plugins: {
    tooltip: {
      callbacks: {
        label: (context) => {
          const label = context.dataset.label || "";
          if (context.parsed.y !== null) {
            return `${label}: ${
              context.datasetIndex === 1
                ? formats.percent(context.parsed.y)
                : formats.decimal(context.parsed.y)
            }`;
          }
          return label;
        },
      },
    },
  },
  maintainAspectRatio: false,
  scales: {
    x: {
      offset: false,
      grid: {
        offset: false,
      },
    },
    y: {
      type: "linear",
      position: "left",
      beginAtZero: false,
      ticks: {
        callback: (value) => formats.percent(+value),
      },
    },
    y1: {
      type: "linear",
      position: "right",
      beginAtZero: false,
      ticks: {
        callback: (value) => formats.decimal(+value),
      },
      grid: {
        drawOnChartArea: false,
      },
    },
  },
});
